import { defineMessages } from 'react-intl';

export default defineMessages({
  'dt:template_orientation:portrait' : {
    id: 'dt:template_orientation:portrait',
    defaultMessage: 'Portrait'
  }, 
  'dt:template_orientation:landscape' : {
    id: 'dt:template_orientation:landscape',
    defaultMessage: 'Landscape'
  }
});